import React from 'react';
import { useLocation } from 'react-router-dom';
import RailSubmenu from './RailSubmenu';
import {
  LIVE_CASINO_TABS, liveCasinoTabFrom, liveCasinoTabPath,
} from '../lib/liveCasinoTabs';

// Sol raydaki "Canlı Casino" maddesinin alt menüsü (Merit ve Betrun).
// Alt maddeler sayfanın masa sekmeleridir (Tüm Oyunlar hariç — onu ana madde
// zaten açar).
const SUB_ITEMS = LIVE_CASINO_TABS.filter((t) => t.id !== 'all');

const RailLiveSubmenu = ({ prefix, children, onNavigate }) => {
  const location = useLocation();
  const currentTab = location.pathname === '/canli-casino'
    ? liveCasinoTabFrom(location.search)
    : null;
  return (
    <RailSubmenu
      prefix={prefix}
      onNavigate={onNavigate}
      items={SUB_ITEMS}
      currentId={currentTab}
      pathFor={liveCasinoTabPath}
      storageKey="rail:live-sub-open"
      groupLabel="Canlı Casino masaları"
      showLabel="Canlı Casino masalarını göster"
      hideLabel="Canlı Casino masalarını gizle"
    >
      {children}
    </RailSubmenu>
  );
};

export default RailLiveSubmenu;
